import { render, staticRenderFns } from "./DetailViewPopUp.vue?vue&type=template&id=12df22c2&scoped=true&"
import script from "./DetailViewPopUp.vue?vue&type=script&lang=js&"
export * from "./DetailViewPopUp.vue?vue&type=script&lang=js&"
import style0 from "./DetailViewPopUp.vue?vue&type=style&index=0&id=12df22c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df22c2",
  null
  
)

export default component.exports